import hideApplicationFooter from "discourse/helpers/hide-application-footer";
import loadingSpinner from "discourse/helpers/loading-spinner";

export default <template>
  {{loadingSpinner}}
  {{hideApplicationFooter}}
</template>
